import { Col, Input, Row } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

export const DateTimeComponent = ({ value, onChange, disabledField }) => {
  const dateFormat = 'YYYY-MM-DD';
  const timeFormat = 'HH:mm';
  const [dateValue, setSelectedDateValue] = useState(null);


  const updateValue = (newValue) => {
    setSelectedDateValue(newValue);
    onChange(newValue?.toDate());
  };

  const setValues = (date, time) => {
    updateValue(moment(`${date} ${time}`, `${dateFormat} ${timeFormat}`));
  };

  const getDateValue = () => {
    return dateValue?.format(dateFormat);
  };
  const getTimeValue = () => {
    return dateValue?.format(timeFormat);
  };

  const onChangeDate = (e) => {
    const date = e.target.value;
    if (!date) updateValue(null);
    const time = dateValue != null ? dateValue.format(timeFormat) : '00:00';
    setValues(date, time);
  };

  const onChangeTime = (e) => {
    const time = e.target.value;
    if (!time) updateValue(null);
    const date = dateValue != null ? dateValue.format(dateFormat) : moment().format(dateFormat);
    setValues(date, time);
  };

  useEffect(() => {
    if (value == null || Number.isNaN(value)) return;
    setSelectedDateValue(moment(value));
  }, []);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col xs={24} md={12}>
          <Input type="date" value={getDateValue()} onChange={onChangeDate} disabled={disabledField} />
        </Col>
        <Col xs={24} md={12}>
          <Input type="time" value={getTimeValue()} onChange={onChangeTime} disabled={disabledField} />
        </Col>
      </Row>
    </>
  );
};

DateTimeComponent.propTypes = {
  // field: PropTypes.object,
  value: PropTypes.object,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
